import { render, staticRenderFns } from "./loginNew.vue?vue&type=template&id=38189788&scoped=true&"
import script from "./loginNew.vue?vue&type=script&lang=js&"
export * from "./loginNew.vue?vue&type=script&lang=js&"
import style0 from "./loginNew.vue?vue&type=style&index=0&id=38189788&prod&lang=scss&"
import style1 from "./loginNew.vue?vue&type=style&index=1&id=38189788&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38189788",
  null
  
)

export default component.exports